export default {
    //修改组件值
    alterComponentType(context,name){
        context.commit('componentType',name)
    },

     //更新跟团序号
     alterProductId(context,id){
        context.commit('productId',id)
    },

     //更新线路ID
     alterJourneyId(context,id){
        context.commit('journeyId',id)
    },

    //更新当天ID
    alterDayId(context,id){
        console.log("来了"+id)
        context.commit('dayId',id)
    },


}


// WEBPACK FOOTER //
// ./src/vuex/toursVip/action.js